const lang = {
  intro: {
    title: 'Relish your next',
    standfirst: 'dining experience',
    paragraph:
      '<p>Once enrolled, your Global Dining Credit will give you S$200 annually to spend at any of the 2,000+ hand-picked restaurants worldwide featured here.</p>',
    paragraph2:
      'Whether it’s a fine dining establishment or a cosy hidden spot, choose your favourite and we’ll take care of any eligible Statement Credits when you pay with your Platinum Card®.',
    tcLink: 'View full dining benefit details and T&Cs',
    topBanner: {
      show: false,
      heading: 'Great news! Your Dining Credit will renew in January 2025.',
      description:
        'Your current enrolment ends on 31 Dec 2024, however information on how to re-enrol will be provided in January 2025.',
    },
    hotelRestaurant:
      '* Please note that if you’re staying in a hotel, this credit will be applied only when settling the restaurant bill directly with the restaurant, separate from the overall hotel payment.',
  },
  filters: {
    country: 'Country:',
    state: 'State:',
    stateDefault: 'All states',
    city: 'City:',
    cityDefault: 'All cities',
    cuisine: 'Cuisine:',
    cuisineDefault: 'All cuisines',
    postalCode: 'Your postcode:',
    postalCodePlaceholder: 'Enter postcode',
    postalCodeInvalid: 'Invalid postcode format',
    sortBy: 'Sort by',
    alphabetical: 'Alphabetical',
    nearest: 'nearest:',
    clear: 'Clear',
    refineTitle: 'Refine your search',
    refineSubtitle: 'Filter restaurants by location or cuisine type',
    filterModalHeading: 'Filter Restaurants',
    cancel: 'Cancel',
    confirm: 'Confirm',
  },
  results: {
    halal: 'Halal',
    michelin: 'Michelin',
    notAvailable: 'Restaurants not available for this selection',
    noSearchResults: 'No restaurants match your search',
    viewmap: 'View on map',
    makebooking: 'Make a booking:',
    makebookingTel: 'Phone to book:',
    orderOnline: 'To order please visit:',
    deliveryTakeaway: 'Take-Away available',
    deliveryProvidoor: 'Delivery available via Providoor',
    openingSoon: 'Opening soon',
    onlineOnly: 'Online Only',
    new: 'NEW',
    locations: 'Locations',
    button: 'View locations',
    groupCuisine: 'Various cuisines types',
    close: 'Close',
    bookNow: 'Book now',
  },
  tsAndCs: {
    title: 'Terms and Conditions',
    platinum: {
      html: "<ul><li><strong>Maximum amount back is SGD$200</strong>: The redemption period is from 2 March 2026 to 31 December 2026. If you spend on the last day of a redemption period, your transaction may not get captured within that redemption period, so it is recommended to redeem at least 1 day earlier in the period.</li><li><strong>Primary Card Member Only</strong>: The Benefit is only available to basic Card Members of The Platinum Card issued by American Express in Singapore. Transactions made with a Supplementary Card or Additional Card are not eligible for this Platinum Card Benefit.</li><li><strong>Save this Benefit First</strong>: You must first save the Benefit to your Platinum Card before making your payment to qualify for the benefit. If you use another card to make a payment at any time, you will not be eligible for the benefit on that card. </li><li><strong>Eligible Transactions</strong>: Benefit only available for dine-in services made in-person at a participating restaurant outside of Singapore. Full participating restaurant list can be found <a href='https://www.americanexpress.com/en-sg/benefits/diningbenefit/' target='_blank'>here</a>. Participating restaurant list subject to change without notice, please check before you dine as you won’t be eligible to receive a credit if the restaurant isn’t on the list at the time of your transaction. Please note that for dining in Japan, this benefit is only available for bookings on Pocket Concierge which are paid for upfront via Pocket Concierge.</li><li><strong>Excluded Transactions</strong>: Benefit excludes purchases of gift cards and vouchers, transactions made towards deposits charged upfront by the venue, booking, cancellation, and no-show charges, takeaway or dine-at-home services. If you spend in a currency other than Singapore Dollars a Currency Conversion Fee applies and this fee does not count towards the benefit. For more information regarding charges made in foreign currencies refer to your Card Member Agreement.</li><li><strong>Direct Payments Only</strong>: If you pay using payment processors such as QR payment or in restaurant App purchases, you may not be eligible for the benefit. Please request to pay at the restaurants designated till point.</li><li><strong>Award of Credits</strong>: Credit(s) should appear on your billing statement within 30 days from the date of payment but may take longer. Please call the number at the back of your Card (\"Card Services\") should you not receive your credit. Credit(s) are not redeemable for cash or any other payment form.</li><li><strong>Expiry or Withdrawal of Benefit</strong>: The benefit will expire on 31 December 2026. American Express can withdraw the benefit at any time by giving you 30 days’ notice.</li><li><strong>Your use of participating restaurants</strong>: Your purchase of goods and/or services from the participating brands is governed by their respective terms and conditions (including privacy policies). American Express is not responsible in any way for the goods and/or services of the participating brands. Inquiries or complaints related to the participating brands' goods and/or services should be directed to their customer service.</li><li><strong>Our General Offer Terms</strong>: Our <a href='https://www.americanexpress.com/amex/sg/benefits/amexoffers/amex-offers-terms.html' target='_blank'>General Offer Terms</a> also apply to the benefit and contain important additional terms.</li></ul>",
    },
    close: 'Close',
  },
  pocket: {
    title: 'Explore 800+ restaurants and book directly with Pocket Concierge',
    button: 'Visit Pocket Concierge',
  },
  pocketCard: {
    title: 'Pocket Concierge',
    description:
      'Discover and book the best restaurants in Japan (only restaurants accepted prepaid are eligible)',
    cuisines: 'Various cuisines',
    instruction: 'Make a booking:',
    button: 'Visit Pocket Concierge',
  },
  footer: {
    disclaimer:
      "<p>Enrolment is required via Amex Offers in your Online Account or American Express® App. Details of the Offer are available to view in the terms and conditions when enrolling into the Offer.</p><p>”Participating local restaurants” means participating restaurants located in Singapore</p><p>”Participating abroad restaurants” are participating restaurants located outside of Singapore</p><p><a href='https://www.americanexpress.com/en-sg/company/legal/privacy-centre/online-privacy-statement/'>Privacy Statement</a></p><p>Copyright © 2026 American Express Company</p>",
  },
  platinumBanner: {
    title: 'Platinum Benefits Directory',
    text: 'Explore all your Card benefits across travel, entertainment & events, insurance and more. Exclusive to Platinum Card Members.',
    button: 'Visit Platinum Benefits Directory',
  },
}

export default lang
